/* eslint-disable @typescript-eslint/no-empty-function */
import bootstrap from './bootstrap';
bootstrap(() => {});
